import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedAdminRoute = ({ children }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
     return (
      <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900">
        <div className="text-gray-500 dark:text-gray-400">Verifying access...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  if (!user || !['ADMIN', 'MODERATOR'].includes(user.role)) {
    // If logged in but not admin, redirect to home or show error
    // For now redirect to admin login which might show they are logged in as user?
    // Better redirect to home if they are already logged in as regular user.
    return <Navigate to="/" replace />; 
  }

  return children;
};

export default ProtectedAdminRoute;
